import convertCurrencyFormat from '@zola-helpers/client/dist/es/util/convertCurrencyFormat';
import { WPriceRangeView } from '@zola/svc-web-api-ts-client';

export const getFormattedPrice = (priceRange: WPriceRangeView | undefined) => {
  if (!priceRange) {
    return '';
  }
  // price - need to handle MSRP and sale stuff ?

  const { min_price: minPrice, max_price: maxPrice } = priceRange || {};

  const minPriceFractionDigits = minPrice && (minPrice / 100) % 1 > 0 ? 2 : 0;
  const lowerBoundPrice = minPrice
    ? convertCurrencyFormat(minPrice / 100, 'USD', minPriceFractionDigits, 2)
    : 0;
  const hasPriceRange = minPrice && maxPrice && minPrice < maxPrice;
  const maxPriceFractionDigits = maxPrice && (maxPrice / 100) % 1 > 0 ? 2 : 0;
  const upperBoundPrice = hasPriceRange
    ? convertCurrencyFormat(maxPrice / 100, 'USD', maxPriceFractionDigits, 2)
    : null;
  return `${lowerBoundPrice}${upperBoundPrice ? ` - ${upperBoundPrice}` : ''}`;
};
